import API from 'services/API';

export default function getPropertyObjectsShort({ year, isDefault = true } = {}) {
  return API.request({
    method: 'GET',
    url: '/property/shortScenarios',
    params: { year, isDefault },
  });
}
